import React  from 'react';
import {BreadcrumbItem} from "reactstrap";
import {Link} from "react-router-dom";

function OrganizationsBreadcrumb () {
  return <BreadcrumbItem><Link to='/organizations'>Organizations</Link></BreadcrumbItem>
}

export default OrganizationsBreadcrumb;
